import React from 'react';

const GalleryHorizontalEndIcon = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
             height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
             stroke={props.stroke ? props.stroke : 'currentColor'}
             strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
             strokeLinejoin="round"
        >
            <path d="M2 7v10"/>
            <path d="M6 5v14"/>
            <rect width="12" height="18" x="10" y="3" rx="2"/>
        </svg>
    );
};

export default GalleryHorizontalEndIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/GalleryHorizontalEndIcon.jsx